//@ts-nocheck
import { ChartData } from "chart.js";
import { COLORS } from "../../constants/design/colors";
import { downColor, upColor } from "./helpers";

export const buildChartData = (
  canvas: any,
  {
    priceRange,
    breakeven,
    price,
    calculateProfit,
    findNeighbourPoint,
  }: {
    priceRange: number[];
    breakeven: number;
    price: number;
    calculateProfit: (p: number) => number;
    findNeighbourPoint: (nums: number[], point: number) => number[];
  }
): ChartData => {
  const ctx = canvas.getContext("2d");
  const green = ctx.createLinearGradient(0, 0, 0, 148);
  green.addColorStop(0, upColor(0.128));
  green.addColorStop(1, upColor(0));
  const red = ctx.createLinearGradient(0, 250, 0, 148);
  red.addColorStop(0, downColor(0.16));
  red.addColorStop(1, downColor(0.0384));

  const neighbourPointToBreakeven = findNeighbourPoint(
    priceRange,
    breakeven
  );
  const neighbourPointToPrice = findNeighbourPoint(
    priceRange,
    price
  ).filter((neighbour) => neighbour);
  const closestPricePoint =
    neighbourPointToPrice.length < 2 ||
    Math.abs(price - neighbourPointToPrice[0]) <
      Math.abs(price - neighbourPointToPrice[1])
      ? neighbourPointToPrice[0]
      : neighbourPointToPrice[1];

  const greenData = priceRange.map((p) =>
    neighbourPointToBreakeven.includes(p) || calculateProfit(p) >= 0
      ? calculateProfit(p)
      : null
  );
  const redData = priceRange.map((p) =>
    neighbourPointToBreakeven.includes(p) || calculateProfit(p) <= 0
      ? calculateProfit(p)
      : null
  );
  const priceData = priceRange.map((p) =>
    p === closestPricePoint ? price : null
  );

  return {
    labels: priceRange,
    datasets: [
      {
        label: "breakeven",
        data: priceRange.map(() => 0),
        type: "line",
        pointRadius: 0,
        pointHoverRadius: 0,
        borderColor: COLORS.white.two,
        borderWidth: 1,
        lineTension: 0,
      },
      {
        label: "green",
        data: greenData,
        type: "line",
        pointRadius: 0,
        pointHoverRadius: 0,
        borderDash: undefined,
        borderWidth: 1,
        borderColor: upColor(),
        backgroundColor: green,
        fill: "-1",
        lineTension: 0,
      },
      {
        label: "red",
        data: redData,
        type: "line",
        pointRadius: 0,
        pointHoverRadius: 0,
        borderDash: undefined,
        borderWidth: 1,
        borderColor: downColor(),
        backgroundColor: red,
        fill: "-2",
        lineTension: 0,
      },
      {
        label: "price",
        data: priceData,
        type: "line",
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
  };
};
